module.exports = __webpack_public_path__ + "static/media/ic_card_kyc_underprocess.cb945470.svg";